import { useLazyQuery, useMutation } from "@apollo/client/react";
import { gql } from "@apollo/client";
import toast from "react-hot-toast";
import { AuthorizationCheckRequired, eventBus } from "@/state";

var getTagsQuery = gql`
  query tags($organizationId: UUID!){
    tags(organizationId: $organizationId)
    {
      id
      name
      type
      is_protected
    }
  }
`;


var getTagQuery = gql`
  query tag($organizationId: UUID!, $tagId: UUID!){
    tag(organizationId: $organizationId, tagId: $tagId)
    {
      id
      name
      type
      is_protected
    }
  }
`;



export var deleteTagMutation = gql`
    mutation deleteTag($organizationId: UUID!, $id: UUID!) {
        deleteTag(organizationId: $organizationId,  id: $id) 
    }  
`;



var getResourceTagsQuery = gql`
 query resourceTags($organizationId: UUID!, $type: Models!, $resourceId: UUID!){
    resourceTags(organizationId: $organizationId, type: $type, resourceId: $resourceId)
    {
      resource_id
      tag_id
      type
      tag {
        name
        is_protected
      }
      application_id
      asset_id
      contact_id
    }
  }
`;




export function useTagActions() {

    const [apiGetTags] = useLazyQuery(getTagsQuery);
    const [apiGetTag] = useLazyQuery(getTagQuery);
    const [apiDeleteTag] = useMutation(deleteTagMutation);
    const [apiGetResourceTags] = useLazyQuery(getResourceTagsQuery);

    




    function GetResourceTags(organizationId: string, type: string, resourceId: string) {
        if(!organizationId) throw "No organization selected";

        return new Promise(async (resolve, reject) => {
            apiGetResourceTags(
                {variables: {
                    organizationId,
                    type, 
                    resourceId
                }}
            )
            .then((result: any) => result?.data?.resourceTags)
            .then((result) => resolve(result))
            .catch((err) => {
                let data =  JSON.parse(JSON.stringify(err))
                if(data?.message?.includes("user is not authorized"))
                {
                    eventBus.next({type: AuthorizationCheckRequired})
                }

                toast.error("Api Error, Unable to get tag");
                reject(err);
            })
        })
    }


    function DeleteTag(organizationId: string, tagId: string) {
        if(!organizationId) throw "No organization selected";

        return new Promise(async (resolve, reject) => {
            apiDeleteTag(
                {variables: {
                    organizationId,
                    id: tagId
                }}
            )
            .then((result: any) => result?.data?.deleteTag)
            .then((result) => resolve(result))
            .catch((err) => {
                let data =  JSON.parse(JSON.stringify(err))
                if(data?.message?.includes("user is not authorized"))
                {
                    eventBus.next({type: AuthorizationCheckRequired})
                }

                toast.error("Api Error, Unable to delete tag");
                reject(err);
            })
        })
    }



    function GetTag(organizationId: string, tagId: string) {
        if(!organizationId) throw "No organization selected";

        return new Promise(async (resolve, reject) => {
            apiGetTag(
                {variables: {
                    organizationId,
                    tagId
                }}
            )
            .then((result: any) => result?.data?.tag)
            .then((result) => resolve(result))
            .catch((err) => {
                let data =  JSON.parse(JSON.stringify(err))
                if(data?.message?.includes("user is not authorized"))
                {
                    eventBus.next({type: AuthorizationCheckRequired})
                }

                toast.error("Api Error, Unable to get tag");
                reject(err);
            })
        })
    }
    

    function GetTags(organizationId: string) {
        if(!organizationId) throw "No organization selected";

        return new Promise(async (resolve, reject) => {
            apiGetTags(
                {variables: {
                    organizationId: organizationId,
                }}
            )
            .then((result: any) => result?.data?.tags)
            .then((result) => resolve(result))
            .catch((err) => {
                let data =  JSON.parse(JSON.stringify(err))
                if(data?.message?.includes("user is not authorized"))
                {
                    eventBus.next({type: AuthorizationCheckRequired})
                }

                toast.error("Api Error, Unable to get tags");
                reject(err);
            })
        })
    }

    
    return {
        GetTags,
        GetTag,
        DeleteTag,
        GetResourceTags
    };
}




